import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useSearchParams } from 'react-router';
import { useDeviceSelectors } from 'react-device-detect';
import { useIntl } from 'react-intl';
import classNames from 'classnames';
import { processFormError } from '../../../utils/processFormError';
import Loader from '../../../components/base/Loader/Loader';
import { Icons } from '../../../components/base/BootstrapComponents/BootstrapComponents';
import {
  authorizedCheck, authorizedESIALogin, authorizedLogin, forgotPassword, getESIAUrl,
} from '../actions';
import { getResponseError, getURLParams, responseLogWithNotification } from '../../../utils/utils';
import { calculateBaseRoute } from '../../../utils/routeByRoles';
import { startLoadApp, endLoadApp } from '../../System/actions';
import { getAuthorizedData } from '../reducer';
import { LOCAL_STORAGE_UPDATE_PERIOD } from '../../../configs/names';
import { errorNotification } from '../../Notifications/notificationDecorator';

export default function LoginPage() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const {
    loggedIn, loginProcess, loadingForgotPassword, loadingRedirectUrl, loadingEsiaRedirectUrl,
  } = useSelector(getAuthorizedData);
  const [selectors] = useDeviceSelectors(window.navigator.userAgent);
  const { formatMessage } = useIntl();
  const { isMobile } = selectors;
  useEffect(() => {
    if (loggedIn) {
      const baseRoute = calculateBaseRoute(true, [], null, isMobile, true);
      navigate(baseRoute || '/');
    }
  }, []);
  const [error, setError] = useState('');

  const handleLogin = values => {
    setError('');
    Object.keys(localStorage).forEach(key => {
      if (key.includes('filter')) {
        localStorage.removeItem(key);
      }
    });
    window.localStorage.setItem(LOCAL_STORAGE_UPDATE_PERIOD, 300);
    dispatch(authorizedLogin()).catch(response => {
      // errorNotification('Загрузка реестровых данных', getResponseError(response))
      responseLogWithNotification(response, formatMessage({ id: 'app.login' }), formatMessage({ id: 'error.default' }));
      setError(processFormError(response));
    });
  };

  const handleESIALogin = values => {
    setError('');
    Object.keys(localStorage).forEach(key => {
      if (key.includes('filter')) {
        localStorage.removeItem(key);
      }
    });
    window.localStorage.setItem(LOCAL_STORAGE_UPDATE_PERIOD, 300);

    const url = window.location.href;

    dispatch(getESIAUrl({ inviteLink: url.includes('/invite') ? url : null })).catch(response => {
      responseLogWithNotification(response, formatMessage({ id: 'app.login' }), formatMessage({ id: 'error.default' }));
    });
  };

  return (
    <>
      <Loader loading={loginProcess || loadingForgotPassword || loadingRedirectUrl || loadingEsiaRedirectUrl} />
      <div className="login-page-wrapper">
        <div className="login-page">
          <div className="login-logo">
            <Icons customIcon icon="logo-full" />
          </div>
          <div className="form-block-wrapper">
            <div className="form-block">
              <div className="login-block">
                <div className="header">Вход через ЕСИА</div>

                <Icons className="gosuslugi-logo" customIcon icon="gosuslugi" />

                <div className="esia-login-button" onClick={handleESIALogin}>
                  Авторизоваться
                </div>

                <div className="esia-text">
                  Авторизуясь, вы принимаете соглашение на обработку персональных данных.
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
